import { createBrowserClient } from '@supabase/ssr';
import { Database } from '@/types/database.types';
import { Plan } from '@/types/profile';
import { viddyozeProUserEmails } from '@/utils/viddyozeProUserEmails';
// import { Project } from '@/types/project.types';

// Define a function to create a Supabase client for client-side operations
export const createClient = () => {
  return createBrowserClient(
    // Pass Supabase URL and anonymous key from the environment to the client
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
  );
};